import { render, staticRenderFns } from "./Itbis.vue?vue&type=template&id=d277817a"
import script from "./Itbis.vue?vue&type=script&lang=js"
export * from "./Itbis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports